import { SxProps } from '@mui/material';

export const AddNewEntry: SxProps = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-end',
};
